"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompsLifeCycleSym = void 0;
exports.CompsLifeCycleSym = Symbol.for('CompsLifeCycle');
//# sourceMappingURL=interfaces.js.map